import { Injectable } from '@angular/core';
import { CompanyDTO, CompanyToInviteDTO, CPVDTO } from '../../api/plyca-dtos-v2';
import { FormConfig, FormConfigHelper } from '../../components/forms/form.objects';
import { formElementComponent } from '../../components/forms/formElement.component';

@Injectable()
export class ProcurementProjectAYMADCBAMValidations implements FormConfigHelper {
  constructor() { }


  // tslint:disable-next-line: member-ordering
  private static isGoods(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isGoods =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '02<>TIPOEXPTE';
      return isGoods;
    }
    return false;
  }

  // tslint:disable-next-line: member-ordering
  private static isServices(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServices =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '04<>TIPOEXPTE';
      return isServices;
    }
    return false;
  }

  // tslint:disable-next-line: member-ordering
  private static isNewTenderBasedContract(model: any) {
    let newTender = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 1;
    let response = newTender === undefined ? false : (newTender);
    return response;
  }

  public enabledBudgetTotalTaxes(model: any) {
    return true;
  }

  public isOriginCatalogueRequestMaterial(model: any) {
    let originCatalogue = false;
    originCatalogue = (model?._parent?.origin === 'CAT');
    return originCatalogue;
  }

  public isOriginCatalogue(model: any) {
    let originCatalogue = false;
    originCatalogue = (model?.origin === 'CAT');
    return originCatalogue;
  }

  public isVisibleBasedContractReservedContractType(model: any) {
    let visible = false;
    visible = model?.characteristicsContractObject?.reservedContractType !== undefined &&
      model?.characteristicsContractObject.reservedContractType?.properties !== undefined &&
      model?.characteristicsContractObject.reservedContractType?.properties.SUBCONTRATACION === 0 &&
      model?.characteristicsContractObject.basedContractReservedContractType !== undefined;
    return visible;
    //return model.characteristicsContractObject?.isReservedContract && !model?.contractingSystem?.contractReservedContractType?.outsourcing;
  }

  public isVisibleReservedSubcontractData(model: any) {
    let visible = false;
    visible = model?.characteristicsContractObject?.reservedContractType !== undefined &&
      model?.characteristicsContractObject.reservedContractType?.properties !== undefined &&
      model?.characteristicsContractObject.reservedContractType?.properties.SUBCONTRATACION === 1;
    return visible;
  }

  public cleanPercentaje(model: any) {
    if (model?.characteristicsContractObject) {
      if (!model?.characteristicsContractObject?.basedContractReservedSubcontract) {
        model.characteristicsContractObject.basedContractPercentageSubcontracted = undefined;
      }
    }
  }

  public cleanCompanyToInvite(model: any) {
    if (model?.classification && model?.classification?.harmonizedRegulation !== undefined) {
      if (!model?.classification?.harmonizedRegulation) {
        model.breakdownLot.totalLots.companyToInvite_am = undefined;
      } else {
        model.breakdownLot.totalLots.companyToInvite_am = false;
        this.loadTablesCompanyToInviteCBAM(model);
      }
    }
  }

  public loadTablesCompanyToInviteCBAM(model: any) {
    model.breakdownLot.totalLots.companyToInvites = [];
    //Si se selecciona todas las empresas a invitar (valor 0)
    if (model?.breakdownLot?.totalLots?.companyToInvite_am !== undefined
      && (model?.breakdownLot?.totalLots?.companyToInvite_am === false)) {
      if (model?.breakdownLot?.totalLots?.frameworkAgreementCompanies) {
        model?.breakdownLot?.totalLots?.frameworkAgreementCompanies.forEach((company: CompanyDTO) => {
          // generar objeto company
          let companyToInvite = new CompanyToInviteDTO();
          companyToInvite.company = company;
          model.breakdownLot.totalLots.companyToInvites.push(companyToInvite);
        });
      }
    }
  }

  /*public setCompanyToInviteCBAM(model: any) {
    let _this = this as unknown as formElementComponent;
    if (model?.breakdownLot?.totalLots?.companyToInvite_am !== undefined && !model?.breakdownLot?.totalLots?.companyToInvite_am) {
      // Si es 0 se tienen que seleccionar todas las empresas del AM, que son las que estan en la tabla de Empresas del AM.
      if (model?.breakdownLot?.totalLots?.frameworkAgreementCompanies) {
        let companies = model?.breakdownLot?.totalLots?.frameworkAgreementCompanies;
        companies.forEach((company: CompanyDTO) => {
          // generar objeto company
          let companyToInvite = new CompanyToInviteDTO();
          companyToInvite.company = company;
          _this._addRow(companyToInvite);
        });
      }
    }
  }*/

  // PANEL PRESUPUESTOS
  public enabledBudgetTotalTaxesCBAM(model: any) {
    let enabled = true;
    let noTax = (model.budget && model.budget.budgetBasedContract &&
      model.budget.budgetBasedContract.taxType &&
      model.budget.budgetBasedContract.taxType.identifier === '0<>TIPO_IMPUESTO');
    enabled = !noTax;
    return enabled;
  }
  public enabledBudgetTotalTaxesCBAM_Price(model: any) {
    let enabled = true;
    let noTax = (model.budget && model.budget.taxType && model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');
    enabled = !noTax;
    return enabled;
  }

  public valueBudgetTotalTaxesCBAM(model: any) {
    // Exento de IVA
    let noTax = (model.budget && model.budget.budgetBasedContract &&
      model.budget.budgetBasedContract.taxType &&
      model.budget.budgetBasedContract.taxType.identifier === '0<>TIPO_IMPUESTO');

    // tslint:disable-next-line: max-line-length
    if (model.budget && model.budget.budgetBasedContract && model.budget.budgetBasedContract.taxType && model.budget.budgetBasedContract.taxType.identifier) {
      let taxType = model.budget.budgetBasedContract.taxType.identifier;
      // Exento de IVA
      if (noTax) {
        model.budget.budgetBasedContract.totalTaxes = 0;
      }
    } else {
      // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
      // model.budget.amountExcludingTaxes = 0;
      model.budget.budgetBasedContract.totalTaxes = 0;
      model.budget.budgetBasedContract.totalAmount = 0;
    }
  }

  public valueBudgetTotalTaxesCBAM_Price(model: any) {
    // Exento de IVA
    let noTax = (model.budget && model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');

    // tslint:disable-next-line: max-line-length
    if (model.budget && model.budget && model.budget.taxType && model.budget.taxType.identifier) {
      let taxType = model.budget.taxType.identifier;
      // Exento de IVA
      if (noTax) {
        model.budget.totalTaxes = 0;
      }
    } else {
      // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
      // model.budget.amountExcludingTaxes = 0;
      model.budget.totalTaxes = 0;
      model.budget.totalAmount = 0;
    }
  }

  public valueTotalAmountCBAM(model: any) {
    let amountExcludingTaxes = model.budget.budgetBasedContract.amountExcludingTaxes;
    let totalTaxes = model.budget.budgetBasedContract.totalTaxes;

    // tslint:disable-next-line: max-line-length
    let total = (amountExcludingTaxes === undefined && totalTaxes === undefined) ? 0.0 : (amountExcludingTaxes === undefined) ? totalTaxes : (totalTaxes === undefined) ? amountExcludingTaxes :
      (amountExcludingTaxes + totalTaxes);
    let multiplier = Math.pow(10, 2);
    return Math.round((total + Number.EPSILON) * multiplier) / multiplier;
  }

  public valueTotalAmountCBAM_Price(model: any) {
    let amountExcludingTaxes = model.budget?.amountExcludingTaxes;
    let totalTaxes = model.budget?.totalTaxes;

    // tslint:disable-next-line: max-line-length
    let total = (amountExcludingTaxes === undefined && totalTaxes === undefined) ? 0.0 : (amountExcludingTaxes === undefined) ? totalTaxes : (totalTaxes === undefined) ? amountExcludingTaxes :
      (amountExcludingTaxes + totalTaxes);
    let multiplier = Math.pow(10, 2);
    return Math.round((total + Number.EPSILON) * multiplier) / multiplier;
  }

  public visibilityPriceData(model: any) {
    let newTender = ProcurementProjectAYMADCBAMValidations.isNewTenderBasedContract(model);
    //let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    //let visible = !someEntrepreneurs || (someEntrepreneurs && !newTender);
    return !newTender;
  }

  public editablePartialReceptions(model: any) {
    let existPartialReception = model?.breakdownLot?.totalLots?.partialPeriod?.partialDeliveryDescription !== undefined &&
      model?.breakdownLot?.totalLots?.partialPeriod?.partialDeliveryDescription !== '';
    return existPartialReception;
  }

  public valuePartialReceptions(model: any, changes: any) {
    let existPartialDeliveryDescription = model?.breakdownLot?.totalLots?.partialPeriod?.partialDeliveryDescription !== undefined &&
    model?.breakdownLot?.totalLots?.partialPeriod?.partialDeliveryDescription !== '';
  if (!existPartialDeliveryDescription) {
    model.breakdownLot.totalLots.partialPeriod.partialReceptions = undefined;
    return undefined;
  } else {
    return model.breakdownLot.totalLots.partialPeriod.partialReceptions;
  }

    /*let oldValue = undefined;
    let newValue = undefined;

    if (changes?.oldValue != null) {
      oldValue = changes.oldValue;
    }
    if (changes?.newValue != null) {
      newValue = changes.newValue;
    }

    if (oldValue === undefined || oldValue === '') {
      model.breakdownLot.totalLots.partialPeriod.partialReceptions = undefined;
      return false;
    } else {
      let existPartialReception = model?.breakdownLot?.totalLots?.partialPeriod?.partialDeliveryDescription !== undefined &&
        model?.breakdownLot?.totalLots?.partialPeriod?.partialDeliveryDescription !== '';
      if (!existPartialReception) {
        model.breakdownLot.totalLots.partialPeriod.partialReceptions = false;
        return false;
      }
    }*/

  }

  public visibleExpectedStartDate(model: any) {
    return ProcurementProjectAYMADCBAMValidations.isServices(model);
  }

  public isVisibleWorkProgramCBAM(model: any) {
    let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    return ProcurementProjectAYMADCBAMValidations.isServices(model) && someEntrepreneurs;
  }

  public isGoodsOrServicesCBAM(model: any) {
    let isGoods = ProcurementProjectAYMADCBAMValidations.isGoods(model);
    let isServices = ProcurementProjectAYMADCBAMValidations.isServices(model);
    return isGoods || isServices;
  }

  public isServicesCBAM(model: any) {
    return ProcurementProjectAYMADCBAMValidations.isServices(model);
  }

  public visibleDataCessionCBAM(model: any) {
    // Cuando el AM tiene cesion de datos o cesion de datos de subcontratacion se visualiza el panel de cesion de datos.
    // Se comprueba siempre el AM, ya que si se selecciona que el basado tiene cesion de datos, se tiene que traer la descripcion.
    let exp_Rdl_14_2019 = model?.exp_Rdl_14_2019;
    let visible = false;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    let frameworkAgreementDataCession = false;
    if (exp_Rdl_14_2019) {
      if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
        frameworkAgreementDataCession = model?.procurementProjectAM?.breakdownLot?.lots[0].dataCession;
      } else {
        frameworkAgreementDataCession = model?.procurementProjectAM?.breakdownLot?.totalLots?.dataCession;
      }
      visible = frameworkAgreementDataCession;
    }
    return visible;
  }

  public visibleDataOutsourcingCBAM(model: any) {
    // Cuando el AM tiene cesion de datos o cesion de datos de subcontratacion se visualiza el panel de cesion de datos.
    // Se comprueba siempre el AM, ya que si se selecciona que el basado tiene cesion de datos, se tiene que traer la descripcion.
    let exp_Rdl_14_2019 = model?.exp_Rdl_14_2019;
    let visible = false;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    let frameworkAgreementDataOutsourcing = false;
    if (exp_Rdl_14_2019) {
      if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
        frameworkAgreementDataOutsourcing = model?.procurementProjectAM?.breakdownLot?.lots[0].dataOutsourcing;
      } else {
        frameworkAgreementDataOutsourcing = model?.procurementProjectAM?.breakdownLot?.totalLots?.dataOutsourcing;
      }
      visible = frameworkAgreementDataOutsourcing;
    }
    return visible;
  }

  public valueDataCessionDescCBAM(model: any) {
    let exp_Rdl_14_2019 = model?.exp_Rdl_14_2019;
    let description = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    let frameworkAgreementDataCession = false;
    if (exp_Rdl_14_2019 && model?.breakdownLot?.totalLots?.dataCession) {
      if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
        frameworkAgreementDataCession = model?.procurementProjectAM?.breakdownLot?.lots[0].dataCession;
        if (frameworkAgreementDataCession) {
          description = model?.breakdownLot?.totalLots?.dataCessionDesc ?
            model?.breakdownLot?.totalLots?.dataCessionDesc :
            (model?.procurementProjectAM?.breakdownLot?.lots[0].dataCessionDesc);
        }
      } else {
        frameworkAgreementDataCession = model?.procurementProjectAM?.breakdownLot?.totalLots?.dataCession;
        if (frameworkAgreementDataCession) {
          description = model?.procurementProjectAM?.breakdownLot?.totalLots?.dataCessionDesc;
        }
      }
    }
    return description;
  }


  public valueDataOutosurcingDescCBAM(model: any) {
    let exp_Rdl_14_2019 = model?.exp_Rdl_14_2019;
    let description = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    let frameworkAgreementDataOutsourcing = false;
    if (exp_Rdl_14_2019 && model?.breakdownLot?.totalLots?.dataOutsourcing) {
      if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
        frameworkAgreementDataOutsourcing = model?.procurementProjectAM?.breakdownLot?.lots[0].dataOutsourcing;
        if (frameworkAgreementDataOutsourcing) {
          description = model?.procurementProjectAM?.breakdownLot?.lots[0].dataOutsourcingDesc;
        }
      } else {
        frameworkAgreementDataOutsourcing = model?.procurementProjectAM?.breakdownLot?.totalLots?.dataOutsourcing;
        if (frameworkAgreementDataOutsourcing) {
          description = model?.procurementProjectAM?.breakdownLot?.totalLots?.dataOutsourcingDesc;
        }
      }
    }
    return description;
  }

  public loadFrameworkAgreementCPVCBAM(model: any) {
    let cpvs = undefined;
    if (model?.breakdownLot?.totalLots && model?.breakdownLot?.totalLots?.cpvs !== undefined) {
      let arrayCPV = model.breakdownLot.totalLots.cpvs as Array<any>;
      while (arrayCPV.length > 0) {
        arrayCPV.pop();
      }
    }
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      cpvs = model?.procurementProjectAM?.breakdownLot?.lots[0].cpvs;
    } else {
      cpvs = model?.procurementProjectAM?.breakdownLot?.totalLots?.cpvs;
    }
    if (cpvs) {
      cpvs.forEach((cpv: CPVDTO) => {
        model.breakdownLot.totalLots.cpvs.push(cpv);
      });
    }
  }

  public identifierFrameworkAgreement(model: any) {
    let frameworkAgreementIdentifier = '';
    frameworkAgreementIdentifier = model?._parent.procurementProjectAM?.entity?.division?.project?.identifier;
    return frameworkAgreementIdentifier;
  }

  public lotIdFrameworkAgreement(model: any) {
    let lotId = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      lotId = model?.procurementProjectAM?.breakdownLot?.lots[0].lotId;
    }
    return lotId;
  }

  public lotNumberFrameworkAgreement(model: any) {
    let lotNumber = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      lotNumber = model?.procurementProjectAM?.breakdownLot?.lots[0].lotNumber;
    }
    return lotNumber;
  }

  public lotDescriptionFrameworkAgreement(model: any) {
    let description = '';
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      return model?.procurementProjectAM?.breakdownLot?.lots[0].description;
    }
    return description;
  }

  public visibileAwardOrCompanyToInvite(model: any) {
    let visible = false;
    visible = model?.someEntrepreneurs;
    return visible;
  }

  //Solo consulta si es epis
  public isFrameworkAgreementEpis_CBAM(model: any) {
    let isPrinting = false;
    isPrinting = model?.context?.configurations?.isFrameworkAgreementEpis?.value;
    return isPrinting;
  }

  //Consulta si es epis o imprenta
  public isFrameworkAgreementPrinting_CBAM(model: any) {
    let isPrinting = false;
    isPrinting = model?.context?.configurations?.isFrameworkAgreementPrinting?.value;
    return isPrinting;
  }

  public frameworkAgreementApportioned_CBAM(model: any) {
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    return isApportioned;
  }

  public enabledGuaranteeDescripcion(model: any) {
    let enabledDescription = false;
    enabledDescription = model?.breakdownLot?.totalLots?.budget?.guaranteeProceed_am;
    return enabledDescription;
  }

  public valueGuaranteeDescripcion(model: any) {
    let guaranteeProceed_am = model?.breakdownLot?.totalLots?.budget?.guaranteeProceed_am;
    let value = '';
    if (model?.breakdownLot?.totalLots?.budget) {
      value = guaranteeProceed_am ? model.breakdownLot.totalLots.budget.guaranteeDescription_am : '';
    }
    return value;
  }

  public isNewNoNewTenderFrameworkAgreement(model: any) {
    let editable = false;
    let tenderBasedFrameworkAgreementAdapt;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      tenderBasedFrameworkAgreementAdapt =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    } else {
      tenderBasedFrameworkAgreementAdapt =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    }
    editable = tenderBasedFrameworkAgreementAdapt === 2;

    return editable;
  }

  public isNewTenderFrameworkAgreement(model: any) {
    let editable = false;
    let tenderBasedFrameworkAgreementAdapt;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      tenderBasedFrameworkAgreementAdapt =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    } else {
      tenderBasedFrameworkAgreementAdapt =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    }
    editable = tenderBasedFrameworkAgreementAdapt === 1;

    return editable;
  }

  public isNoNewTenderFrameworkAgreement(model: any) {
    let editable = false;
    let tenderBasedFrameworkAgreementAdapt;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      tenderBasedFrameworkAgreementAdapt =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    } else {
      tenderBasedFrameworkAgreementAdapt =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    }
    editable = tenderBasedFrameworkAgreementAdapt === 0;

    return editable;
  }

  public isEditableTenderFrameworkAgreementCBAM(model: any) {
    let editable = false;
    let isFrameworkAgreementPrinting = model?.context?.configurations?.isFrameworkAgreementPrinting?.value;
    let isNewNoNewTenderFrameworkAgreement = this.isNewNoNewTenderFrameworkAgreement(model);
    editable = !isFrameworkAgreementPrinting && isNewNoNewTenderFrameworkAgreement;
    return editable;
  }

  public visibleObjectiveConditionTenderAward(model: any) {
    let visible = undefined;
    let tenderTypeFrameworkAgreement;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      tenderTypeFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    } else {
      tenderTypeFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    }
    if (tenderTypeFrameworkAgreement !== undefined) {
      if (tenderTypeFrameworkAgreement === 0) {
        visible = true;
      } else if (tenderTypeFrameworkAgreement === 1) {
        visible = false;
      } else if (tenderTypeFrameworkAgreement === 2) {
        let tenderTypeBasedContract = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
        if (tenderTypeBasedContract !== undefined && tenderTypeBasedContract !== 1) {
          visible = true;
        } else {
          visible = false;
        }
      }
    }
    return visible;
  }

  public visibleOtherTenderTermsText(model: any) {
    let visible = undefined;
    let tenderTypeFrameworkAgreement;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      tenderTypeFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    } else {
      tenderTypeFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
    }
    if (tenderTypeFrameworkAgreement !== undefined) {
      if (tenderTypeFrameworkAgreement === 1) {
        visible = true;
      } else if (tenderTypeFrameworkAgreement === 2) {
        let tenderTypeBasedContract = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
        if (tenderTypeBasedContract !== undefined && tenderTypeBasedContract === 1) {
          visible = true;
        } else {
          visible = false;
        }
      }
    }
    return visible;
  }

  public getObjectiveConditionTenderAward(model: any) {
    let visibleObjectiveCondition = this.visibleObjectiveConditionTenderAward(model);
    let text = '';
    if (visibleObjectiveCondition) {
      text = 'Condiciones objetivas para determinar la empresa adjudicataria del contrato basado en el PCAP del Acuerdo Marco';
    }
    return text;
  }

  public getOtherTenderTermsText(model: any) {
    let text = '';
    let tenderTypeFrameworkAgreement;
    let othersTendersFrameworkAgreement;
    let isApportioned = model?.procurementProjectAM?.breakdownLot?.apportioned;
    if (isApportioned && model?.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      tenderTypeFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.tenderBasedFrameworkAgreementAdapt;
      othersTendersFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.lots[0].contractingSystem?.othersTenders;
    } else {
      tenderTypeFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
      othersTendersFrameworkAgreement =
        model?.procurementProjectAM?.breakdownLot?.totalLots?.contractingSystem?.othersTenders;
    }
    if (tenderTypeFrameworkAgreement !== undefined) {
      if (tenderTypeFrameworkAgreement === 1) {
        if (othersTendersFrameworkAgreement) {
          text = 'Basada en los términos señalados en el Acuerdo Marco y que se concretan en el documento de licitacion';
        } else {
          text = 'Basada en los mismos términos aplicados a la adjudicación del Acuerdo Marco';
        }
      } else if (tenderTypeFrameworkAgreement === 2) {
        let tenderTypeBasedContract = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
        if (tenderTypeBasedContract !== undefined && tenderTypeBasedContract === 1) {
          if (othersTendersFrameworkAgreement !== undefined) {
            if (othersTendersFrameworkAgreement) {
              text = 'Basada en los términos señalados en el Acuerdo Marco y que se concretan en el documento de licitacion';
            } else {
              text = 'Basada en los mismos términos aplicados a la adjudicación del Acuerdo Marco';
            }
          }
        } else {
          text = 'Basada en los términos señalados en el Acuerdo Marco y que se concretan en el documento de licitacion';
        }
      }
    }
    return text;
  }

  public getLotIdSearchAward(model: any) {
    let lotId = '0';
    let isFrameworkAgreemtnApportioned = model?._parent.procurementProjectAM?.breakdownLot?.apportioned;
    if (isFrameworkAgreemtnApportioned && model?._parent.procurementProjectAM?.breakdownLot?.lots?.length > 0) {
      lotId = model?._parent.procurementProjectAM?.breakdownLot?.lots[0].lotId;
    }
    return lotId;
  }

  public getSelectedCompany(model: any) {
    if (model?._parent?.breakdownLot?.totalLots?.companyToInvites) {
      let companies = model?._parent?.breakdownLot?.totalLots?.companyToInvites;
      let filter = '';
      companies.forEach((companyToInvite: CompanyToInviteDTO) => {
        if (companyToInvite?.company && companyToInvite?.company?.taxIdentifier !== undefined) {
          filter = filter + "'" + companyToInvite.company.taxIdentifier + "',";
        }
      });
      if (filter !== '') {
        filter = filter.substring(1).slice(0, -2);
      }
      return filter;
    }
  }

  public valueDropdowncompanyToInvite_amCBAM(model: any) {
    let value = undefined;
    if (model?.breakdownLot?.totalLots?.companyToInvite_am !== undefined) {
      if (model?.breakdownLot?.totalLots?.companyToInvite_am === false) {
        value = 0;
      } else {
        value = 1;
      }
    }
    value = (model.classification.harmonizedRegulation ? 0 : model.breakdownLot.totalLots.companyToInvite_am)
    return value;
  }

  public visibleTableAllAwardCompanies(model: any) {
    let visible = false;
    let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    let isNewTenderBasedContract = model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt
      && model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 1;
    let selectAllCompanies = model?.breakdownLot?.totalLots?.companyToInvite_am !== undefined
      && !model?.breakdownLot?.totalLots?.companyToInvite_am;
    visible = someEntrepreneurs && (isNewTenderBasedContract && selectAllCompanies);
    return visible;
  }

  public addEnabledTableAwardCompanies(model: any) {
    let addEnabled = true;
    let isNewTenderBasedContract = model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt
      && model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 1;
    let totalRows = 0;
    if (model.breakdownLot.totalLots.companyToInvites !== undefined) {
      totalRows = model.breakdownLot.totalLots.companyToInvites.length;
    }
    addEnabled = isNewTenderBasedContract || (!isNewTenderBasedContract && totalRows <= 0);
    return addEnabled;
  }

  public visibleTableAwardCompanies(model: any) {
    let visible = false;
    let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    let noNewOrAuthomaticTenderBasedContract =
      model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt !== undefined
      && (model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 0
        || model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 3);
    let isNewTenderBasedContract = model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt
      && model.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 1;
    let selectCompanies = model?.breakdownLot?.totalLots?.companyToInvite_am !== undefined
      && model?.breakdownLot?.totalLots?.companyToInvite_am;
    visible = someEntrepreneurs && (noNewOrAuthomaticTenderBasedContract || (isNewTenderBasedContract && selectCompanies));
    return visible;
  }

  public visibleHarmonizedRegulationCBAM(model: any) {
    let visible = false;
    let valAtt = model?.context?.configurations?.isVisibleHarmonizedRegulation?.value;
    let isNewTenderBasedContract = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt === 1;
    let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    visible = valAtt && someEntrepreneurs && isNewTenderBasedContract;
    return visible;
  }

  public clearHarmonizedRegulationCBAM(model: any) {
    model.classification.harmonizedRegulation = undefined;
  }

  public isVisibleReservedBenefit(model: any) {
    let visible = false;
    let exp_Instruccion_1_2022 = model.exp_Instruccion_1_2022;
    let validReservedContractType = model?.characteristicsContractObject?.reservedContractType?.identifier !== undefined &&
      model?.characteristicsContractObject?.reservedContractType.identifier === '14<>TIPOS_CONTRATORESERVADO_AYMAD';
    visible = exp_Instruccion_1_2022 && validReservedContractType;
    return visible;
  }

  /*public valueHarmonizedRegulationCBAM(model: any) {
    let value = undefined;
    let someEntrepreneurs = model.contractingSystem.someEntrepreneurs;
    if (!someEntrepreneurs) {
      value = 0;
    } else {
      let tenderTypeBasedContract = model?.breakdownLot?.totalLots?.contractingSystem?.tenderBasedFrameworkAgreementAdapt;
      if (tenderTypeBasedContract !== undefined && tenderTypeBasedContract === 1) {
        //Con nueva licitacion
        let estimatedAmount = undefined;
        if (model?.budget?.estimatedAmount !== undefined) {
          estimatedAmount = model?.budget?.estimatedAmount;
        }
        let visibleAtt = model?.context?.configurations?.isVisibleHarmonizedRegulation?.value;
        if (visibleAtt) {
          //Si es visible, el valor es el que escoja el usuario.
          value = model.classification.harmonizedRegulation;
        } else {

        }
      } else {
        value = 0;
      }
    }
    return value;
  }*/

  registerFunctions(frmConfig: FormConfig): void {
    // FUNCIONES PARA FICHA EXPEDIENTE CONTRATOS BASADOS //
    frmConfig.functions.push({
      identifier: 'isVisibleBasedContractReservedContractType',
      fn: this.isVisibleBasedContractReservedContractType
    });
    frmConfig.functions.push({
      identifier: 'isVisibleReservedSubcontractData',
      fn: this.isVisibleReservedSubcontractData
    });
    frmConfig.functions.push({
      identifier: 'cleanPercentaje',
      fn: this.cleanPercentaje
    });
    frmConfig.functions.push({
      identifier: 'isOriginCatalogue',
      fn: this.isOriginCatalogue
    });
    frmConfig.functions.push({
      identifier: 'isOriginCatalogueRequestMaterial',
      fn: this.isOriginCatalogueRequestMaterial
    });
    frmConfig.functions.push({
      identifier: 'valueBudgetTotalTaxesCBAM',
      fn: this.valueBudgetTotalTaxesCBAM
    });
    frmConfig.functions.push({
      identifier: 'valueBudgetTotalTaxesCBAM_Price',
      fn: this.valueBudgetTotalTaxesCBAM_Price
    });
    frmConfig.functions.push({
      identifier: 'enabledBudgetTotalTaxesCBAM',
      fn: this.enabledBudgetTotalTaxesCBAM
    });
    frmConfig.functions.push({
      identifier: 'enabledBudgetTotalTaxesCBAM_Price',
      fn: this.enabledBudgetTotalTaxesCBAM_Price
    });
    frmConfig.functions.push({
      identifier: 'valueTotalAmountCBAM',
      fn: this.valueTotalAmountCBAM
    });
    frmConfig.functions.push({
      identifier: 'valueTotalAmountCBAM_Price',
      fn: this.valueTotalAmountCBAM_Price
    });
    frmConfig.functions.push({
      identifier: 'visibilityPriceData',
      fn: this.visibilityPriceData
    });
    frmConfig.functions.push({
      identifier: 'valuePartialReceptions',
      fn: this.valuePartialReceptions
    });
    frmConfig.functions.push({
      identifier: 'editablePartialReceptions',
      fn: this.editablePartialReceptions
    });
    frmConfig.functions.push({
      identifier: 'visibleExpectedStartDate',
      fn: this.visibleExpectedStartDate
    });
    frmConfig.functions.push({
      identifier: 'isVisibleWorkProgramCBAM',
      fn: this.isVisibleWorkProgramCBAM
    });
    frmConfig.functions.push({
      identifier: 'isGoodsOrServicesCBAM',
      fn: this.isGoodsOrServicesCBAM
    });
    frmConfig.functions.push({
      identifier: 'isServicesCBAM',
      fn: this.isServicesCBAM
    });
    frmConfig.functions.push({
      identifier: 'visibleDataCessionCBAM',
      fn: this.visibleDataCessionCBAM
    });
    frmConfig.functions.push({
      identifier: 'visibleDataOutsourcingCBAM',
      fn: this.visibleDataOutsourcingCBAM
    });
    frmConfig.functions.push({
      identifier: 'valueDataCessionDescCBAM',
      fn: this.valueDataCessionDescCBAM
    });
    frmConfig.functions.push({
      identifier: 'valueDataOutosurcingDescCBAM',
      fn: this.valueDataOutosurcingDescCBAM
    });
    frmConfig.functions.push({
      identifier: 'loadFrameworkAgreementCPVCBAM',
      fn: this.loadFrameworkAgreementCPVCBAM
    });
    frmConfig.functions.push({
      identifier: 'lotNumberFrameworkAgreement',
      fn: this.lotNumberFrameworkAgreement
    });
    frmConfig.functions.push({
      identifier: 'lotIdFrameworkAgreement',
      fn: this.lotIdFrameworkAgreement
    });
    frmConfig.functions.push({
      identifier: 'identifierFrameworkAgreement',
      fn: this.identifierFrameworkAgreement
    });
    frmConfig.functions.push({
      identifier: 'lotDescriptionFrameworkAgreement',
      fn: this.lotDescriptionFrameworkAgreement
    });
    frmConfig.functions.push({
      identifier: 'isFrameworkAgreementEpis_CBAM',
      fn: this.isFrameworkAgreementEpis_CBAM
    });

    frmConfig.functions.push({
      identifier: 'isFrameworkAgreementPrinting_CBAM',
      fn: this.isFrameworkAgreementPrinting_CBAM
    });
    frmConfig.functions.push({
      identifier: 'frameworkAgreementApportioned_CBAM',
      fn: this.frameworkAgreementApportioned_CBAM
    });
    frmConfig.functions.push({
      identifier: 'enabledGuaranteeDescripcion',
      fn: this.enabledGuaranteeDescripcion
    });
    frmConfig.functions.push({
      identifier: 'valueGuaranteeDescripcion',
      fn: this.valueGuaranteeDescripcion
    });
    frmConfig.functions.push({
      identifier: 'isNewNoNewTenderFrameworkAgreement',
      fn: this.isNewNoNewTenderFrameworkAgreement.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'visibleObjectiveConditionTenderAward',
      fn: this.visibleObjectiveConditionTenderAward.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'getObjectiveConditionTenderAward',
      fn: this.getObjectiveConditionTenderAward.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'visibleOtherTenderTermsText',
      fn: this.visibleOtherTenderTermsText
    });
    frmConfig.functions.push({
      identifier: 'getOtherTenderTermsText',
      fn: this.getOtherTenderTermsText
    });
    frmConfig.functions.push({
      identifier: 'isEditableTenderFrameworkAgreementCBAM',
      fn: this.isEditableTenderFrameworkAgreementCBAM.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'cleanCompanyToInvite',
      fn: this.cleanCompanyToInvite.bind(this)
    });
    /*frmConfig.functions.push({
      identifier: 'setCompanyToInviteCBAM',
      fn: this.setCompanyToInviteCBAM
    });*/
    frmConfig.functions.push({
      identifier: 'loadTablesCompanyToInviteCBAM',
      fn: this.loadTablesCompanyToInviteCBAM.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'visibleHarmonizedRegulationCBAM',
      fn: this.visibleHarmonizedRegulationCBAM
    });
    frmConfig.functions.push({
      identifier: 'getLotIdSearchAward',
      fn: this.getLotIdSearchAward
    });
    frmConfig.functions.push({
      identifier: 'getSelectedCompany',
      fn: this.getSelectedCompany
    });
    frmConfig.functions.push({
      identifier: 'visibleTableAwardCompanies',
      fn: this.visibleTableAwardCompanies
    });
    frmConfig.functions.push({
      identifier: 'visibleTableAllAwardCompanies',
      fn: this.visibleTableAllAwardCompanies
    });
    frmConfig.functions.push({
      identifier: 'addEnabledTableAwardCompanies',
      fn: this.addEnabledTableAwardCompanies
    });
    frmConfig.functions.push({
      identifier: 'valueDropdowncompanyToInvite_amCBAM',
      fn: this.valueDropdowncompanyToInvite_amCBAM
    });
    frmConfig.functions.push({
      identifier: 'clearHarmonizedRegulationCBAM',
      fn: this.clearHarmonizedRegulationCBAM
    });
    frmConfig.functions.push({
      identifier: 'isVisibleReservedBenefit',
      fn: this.isVisibleReservedBenefit
    });

    /*frmConfig.functions.push({
      identifier: 'valueHarmonizedRegulationCBAM',
      fn: this.valueHarmonizedRegulationCBAM
    });*/



    // FUNCIONES PARA FICHA EXPEDIENTE CONTRATOS BASADOS //
  }
}
